import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {VnaCampaignService} from '../../services/vna-campaign.service';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaCampaignSelected} from '../../model/vna_campaign_selected';

const SELECT_VNA_ACTION_CAMPAIGN_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectVnaCampaignActionComponent)
};

@Component({
    selector: 'app-select-vna-campaign-action',
    template: `
      <ngx-select [items]="actions" [(ngModel)]="action" [optionValueField]="valueField" [optionTextField]="textField" (select)="selected($event)" allowClear="true" >
          <ng-template ngx-select-option ngx-select-option-selected let-option let-text="text">
              {{ option.data.name }} <br />
          </ng-template>
      </ngx-select>
      `,
    styleUrls: ['./select-vna-campaign-action.component.scss'],
    providers: [SELECT_VNA_ACTION_CAMPAIGN_VALUE_ACCESSOR]
})
export class SelectVnaCampaignActionComponent implements OnInit, ControlValueAccessor {

    @Input() valueField: string = 'pk';
    @Input() textField: string = 'name';

    @Input() pkCamp: number;

    actions: Array<Object> = [];
    _action: number;

    constructor(private campHandler: VnaCampaignService, private messaging: MessagingService) { }

    ngOnInit() {
        if(this.pkCamp){
            this.campHandler.findCampaignActions(this.pkCamp).subscribe(
                (result) => {
                    this.actions = result;
                }
            )
        }

        this.messaging.message.subscribe(
            (value) => {
                if(value instanceof VnaCampaignSelected){
                    this.campHandler.findCampaignActions(value.getPkCampaign()).subscribe(
                        (result) => {
                            this.actions = result;
                        }
                    )
                }
            }
        )
    }


    selected(value: any) {
        this.propagateChange(this._action);
    }


    get action(): any { return this._action; };

    set action(v: any) {
        this._action = v;
        this.propagateChange(this._action);
    }

    propagateChange = (_: any) => {};

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
    }

    writeValue(value: any): void {
        this._action = value;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/components/select-vna-campaign-action/select-vna-campaign-action.component.ts